import { Link } from 'react-router-dom';

import { Logo, Wordmark } from './Logo';

export function SiteNav() {
  return (
    <nav className="mx-auto flex max-w-[1120px] items-center gap-3.5 px-6 py-6 md:px-10">
      <Link to="/">
        <Wordmark />
      </Link>
      <div className="ml-auto flex items-center gap-5 md:gap-[30px]">
        <Link
          to="/#how"
          className="hidden font-body text-sm font-medium text-forest-slate hover:text-forest sm:block"
        >
          How it works
        </Link>
        <Link
          to="/#why"
          className="hidden font-body text-sm font-medium text-forest-slate hover:text-forest sm:block"
        >
          Why ClientBridge
        </Link>
        <Link
          to="/#get-started"
          className="rounded-full bg-forest px-5 py-3 font-body text-sm font-semibold text-cream-light hover:bg-forest-deep"
        >
          Get started
        </Link>
      </div>
    </nav>
  );
}

export function SiteFooter() {
  return (
    <footer className="border-t border-hairline-strong">
      <div className="mx-auto flex max-w-[1120px] flex-wrap items-center gap-x-6 gap-y-3 px-6 py-7 md:px-10">
        <div className="flex items-center gap-2">
          <Logo size={45} />
          <span className="font-display text-[15px] font-bold text-forest-deep">
            ClientBridge
          </span>
        </div>
        <span className="font-body text-[13px] text-warm-meta">
          The simplest CRM ever made.
        </span>

        <div className="flex items-center gap-5">
          <Link
            to="/terms"
            className="font-body text-[13px] text-forest-muted hover:text-forest"
          >
            Terms
          </Link>
          <Link
            to="/privacy"
            className="font-body text-[13px] text-forest-muted hover:text-forest"
          >
            Privacy
          </Link>
          <Link
            to="/support"
            className="font-body text-[13px] text-forest-muted hover:text-forest"
          >
            Support
          </Link>
        </div>

        <span className="ml-auto font-mono text-[12.5px] text-warm-faint">
          © {new Date().getFullYear()} ClientBridge
        </span>
      </div>

      {/* Attribution gets its own rule below ClientBridge's own links, the way it does
          on Zator: it belongs to the company behind the product, not to this site's
          navigation, and reads as an aside rather than another footer link. */}
      <div className="border-t border-hairline">
        <div className="mx-auto flex max-w-[1120px] px-6 py-5 md:px-10">
          <a
            href="https://spitballai.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2.5 text-warm-meta transition-colors hover:text-forest"
          >
            <span className="font-mono text-[10.5px] font-semibold uppercase tracking-[0.12em] text-warm-faint">
              Powered by
            </span>
            {/* Decorative: the wordmark beside it already names the company, so a
                second announcement would just be noise to a screen reader. */}
            <img
              src="/assets/images/spitball.png"
              alt=""
              aria-hidden
              className="h-5 w-5 object-contain"
            />
            <span className="font-display text-[13px] font-bold tracking-[-0.01em]">
              Spitball Technologies
            </span>
          </a>
        </div>
      </div>
    </footer>
  );
}
